import React from 'react'

const Manual_proveedores_producto_por_proveedor = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
     <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
     Proveedores - Producto por Proveedor
     </h2>
     <p className="text-lg text-gray-700 mb-6">
     Esta guía proporciona instrucciones esenciales para vincular eficientemente los
    productos con sus respectivos proveedores, garantizando así una gestión precisa
    del inventario. Explica cómo gestionar las conversiones de unidades y las
    cantidades de compra, facilitando el seguimiento de los niveles de existencias y
    los costes.
     </p>
     <iframe
          src="https://scribehow.com/embed/Proveedores__Producto_por_Proveedor__u1oN72LrSTyOo_e8nglyNA?as=scrollable"
          className="scribe-iframe-general-1"
          width="100%"
          height="6020"
          allowFullScreen
          style={{
            aspectRatio: '1 / 1',
            border: 0,
            minHeight: '480px'
          }}
        ></iframe>
   </div>
   </div>
  )
}

export default Manual_proveedores_producto_por_proveedor